export default {
  title: 'Zmenené počas úprav',
  descriptionConflicts: 'Tieto údaje boli medzitým uložené. Kliknite na hodnotu, ktorú chcete ponechať, pri každom poli, ktoré ste tiež zmenili.',
  descriptionServerChanges: 'Tieto údaje boli medzitým uložené. Tieto zmeny sa použijú spolu s vašimi. Vráťte tie, ktoré nechcete ponechať.',
  notSaved: 'Neuložené',
  field: 'Pole',
  keepAll: 'Ponechať všetky hodnoty',
  keeping: 'Ponecháva sa',
  you: 'Vy',
  combined: 'Ponechať obe (najprv verzia na serveri)',
  added: 'Pridané',
  removed: 'Odstránené',
  missing: 'Neexistuje',
  value: 'Hodnota',
  positionStart: 'Na začiatku',
  positionAfter: 'Za {item}',
  resolvedCount: 'Vyriešené konflikty: {resolved} z {total}',
  saveDisabled: 'Zostávajúce polia bez zvolenej hodnoty: {count}',
  serverChanges: 'Zmeny vo verzii na serveri bez konfliktu: {count}',
  show: 'Zobraziť zmeny',
  hide: 'Skryť zmeny',
  revert: 'Vrátiť zmenu',
  restore: 'Obnoviť zmenu',
  reverted: 'Vaša hodnota zostáva',
  cancelTooltip: 'Zahodiť vaše zmeny a pokračovať v úpravách verzie na serveri',
  latestMissing: 'Tieto údaje boli počas vašich úprav na serveri odstránené. Vaše zmeny nie je možné uložiť.',
  version: {
    original: 'Pôvodná verzia',
    latest: 'Verzia na serveri',
    edited: 'Vaša verzia',
  },
};
